import React from 'react'
import { Widget, mk_widget, Action, loadingAsyncState } from 'widgets-for-react'
import { WordPress } from '../../wordpress/wordpress_api'
import { Link } from 'react-router-dom'
import { Page, TemplateState } from '../../cms/page/types.gen'
import { CustomBlock } from '../../wordpress/types_and_parser/custom_blocks.mod'
import { Block } from '../../wordpress/types_and_parser/standard_blocks.gen'
import { PublicSite_CustomPageData } from '../application.mod'
import { toRelativeUrl } from '../../../helpers'
import { CustomBlockData } from '../blocks/custom_blocks/types.mod'
import { ExtraImages, getImageSize } from '../utils/extra_images.mod'
import { Pagination } from './pagination.mod'
import moment from 'moment'
import { HeroBlock } from '../blocks/custom_blocks/widgets/heroBlock.mod'
import { heroBlockClasses } from '../blocks/style.mod'
import { CMSState } from '../../cms/blocks/types.gen'
import { PublicSiteState } from '../../public_site.main.mod'
import { breadcrumb } from '../../../styleguide/components/components/pageHeader'

export const postOverview: (
  page: Page<CustomBlock, Block, PublicSite_CustomPageData>,
  type: 'update',
  state: PublicSiteState
) => Widget<Action<TemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData>>> = (
  page: Page<CustomBlock, Block, PublicSite_CustomPageData>,
  type: 'update',
  state: PublicSiteState
) =>
    mk_widget({
      run: setState => {
        const pageHeader = state.page.blocks.find(block => block.kind == 'heroBlock');
        // page.blocks.splice(state.page.blocks.keyOf(pageHeader))

        let posts = page.extra_data.updates

        return (
          <>
            { pageHeader && pageHeader.kind == 'heroBlock' && 
              HeroBlock({
                ...pageHeader.value.fst,
              },
              { style: heroBlockClasses }
            )({} as CMSState<{}, {}, never>)(state).run(_ => {})}
            { state.page.custom_page_data &&
              state.page.custom_page_data.v.kind == 'r' &&
              state.page.custom_page_data.v.v.post.breadcrumb &&
              state.page.custom_page_data.v.v.post.breadcrumb.itemListElement &&
              !state.page.custom_page_data.v.v.post.is_front && (
                breadcrumb(state.page.custom_page_data.v.v.post.breadcrumb.itemListElement.map(crumb => crumb.item['@id'] ? ({ title: crumb.item.name, url: crumb.item['@id'] }) : undefined).filter(item => item != undefined))
              )
            }
            {posts.async.kind == "loaded" ? (
              <>
                <section className="block block--grid block--overview">
                  <div className="block__inner container container--l grid--block">
                    <div className="block__content">
                      <ul className="block__grid grid c--columns">
                        {posts.async.value.posts.map(post => update_post(post))}
                      </ul>
                    </div>
                    <Pagination
                      pager={{
                        current_page: posts.current_page,
                        items_per_page: 12,
                        total_items: posts.async.value.total_articles,
                        total_pages: posts.async.value.total_pages
                      }}
                      setPage={(new_page: number) =>
                        setState(s => {
                          return s.page.kind == "loaded"
                            ? {
                                ...s,
                                page: {
                                  ...s.page,
                                  value: {
                                    ...s.page.value,
                                    extra_data: {
                                            ...s.page.value.extra_data,
                                            updates: {
                                              ...s.page.value.extra_data.updates,
                                              async: get_posts(new_page, type),
                                              current_page: new_page
                                            }
                                          }
                                  }
                                }
                              }
                            : s;
                        })
                      }
                    />
                  </div>
                </section>
              </>
            ) : (
              <section className="block block--grid block--overview">
                <div className="block__inner container--xl grid--block">
                  <div className="loader loader--page">
                    <div className="loader__inner">
                      <svg className="loader__icon" width="60px" height="60px" aria-hidden="true">
                        <use xlinkHref="#icon--loader" />
                        <span className="sr-only">Loading...</span>
                      </svg>
                    </div>
                  </div>
                </div>
              </section>
            )}
          </>
        );
      }
    })

function update_post (post: WordPress.UpdateResponse) {
  return (
    <li className="grid__item item">
      <article className="grid__article">
        <Link className="grid__inner grid__link grid__link--image" to={toRelativeUrl(post.link)}>
          <div className="grid__content grid__content--image">
            <header className="grid__header">
              <h3 className="grid__title typo--m">{post.title.rendered}</h3>
              <time className="grid__date" date-time={moment(post.date).locale(window.wp.language).format("DD-MM-YYYY")}>
                {moment(post.date)
                  .locale(window.wp.language)
                  .format("DD-MM-YYYY")}
              </time>
            </header>
            <svg className="grid__icon"
              width="25px"
              height="14px"
              aria-hidden="true"
            >
              <use xlinkHref="#icon--arrow" />
            </svg>
          </div>

          {post.featured_media && (
            <div className="grid__visual">
              <img
                src={getImageSize(post.featured_media, '1320x765')}
                data-src={getImageSize(post.featured_media, '440x255')}
                data-srcset={[
                  [getImageSize(post.featured_media, '440x255') + ' 440w'],
                  [getImageSize(post.featured_media, '880x510') + ' 880w'],
                  [getImageSize(post.featured_media, '1320x765') +' 1320w'],
                ]}
                data-sizes="auto"
                width="440" 
                height="255"
                className="grid__image"
              />
            </div>
          )}
        </Link>
      </article>
    </li>
  );
}


export function get_posts (page, postType: 'update') {
  page = page == 0 ? null : page + 1
  return loadingAsyncState<WordPress.OverviewResponse>(_ =>
    WordPress.api<WordPress.UpdateResponse>()
      .select(postType)
      .where({ per_page: 12, page: page })
      .getMultiple()
      .then(response => response.data
        ? { kind: 'result', status: 200, value: {
          total_pages: response.headers["x-wp-totalpages"],
          total_articles: response.headers["x-wp-total"],
          kind: postType,
          posts: response.data
        } } : {
          kind: 'failed',
          status: 404
        }
      )
  )
}


// WEBPACK FOOTER //
// ./Client/components/public_site/templates/post_overview.mod.tsx